import { render } from "./StatisticsBaseSwitchTab.vue?vue&type=template&id=1b0a4742&ts=true"
import script from "./StatisticsBaseSwitchTab.vue?vue&type=script&lang=ts"
export * from "./StatisticsBaseSwitchTab.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__